import { render, staticRenderFns } from "./submitted-files.vue?vue&type=template&id=82fc1fd4&"
import script from "./submitted-files.vue?vue&type=script&lang=ts&"
export * from "./submitted-files.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports